/* eslint-disable no-console */
import { getCookie, setCookie, deleteCookie } from '../utils/cookie-functions';
import updateShopifyCustomerTags from '../utils/privacy/update-customer-tags';

export default (element) => {
  const inputs = element.querySelectorAll('input[type="checkbox"]');
  const submitButton = element.querySelector('button#submit-button');
  const cancelButton = element.querySelector('#cancel-button');
  const privacyMessage = element.querySelector('.gpc-message');
  const privacyControl = navigator.globalPrivacyControl;

  // TODO: Enable this?
  // updateGPCinOneTrust(privacyControl);

  // Access the data-section-data element
  const sectionDataElement = element.querySelector('script[data-section-data]');
  const sectionData = JSON.parse(sectionDataElement?.textContent);

  // Log the id and tags
  const { customerId, customerTags } = sectionData;

  if (privacyControl) {
    inputs.forEach((el) => {
      // eslint-disable-next-line no-param-reassign
      el.checked = true;
      // eslint-disable-next-line no-param-reassign
      el.disabled = true;
    });
    submitButton.disabled = true;
    cancelButton.setAttribute('disabled', 'disabled');
    cancelButton.classList.add('disabled');
    cancelButton.addEventListener('click', (e) => {
      e.preventDefault();
    });
    if (privacyMessage) privacyMessage.classList.remove('hidden');
    return;
  }

  const isCookieSet = (acceptance) => {
    const isSet = getCookie(acceptance);
    return isSet === true || isSet === 'true';
  };

  const isTagInShopify = (acceptance) => {
    return customerTags.includes(acceptance);
  };

  inputs.forEach((el) => {
    if (customerId) {
      const tags = [...customerTags];
      const shouldBeChecked = el.dataset.acceptance?.split(',').some((acceptance) => {
        const cookieIsSet = isCookieSet(acceptance);
        const tagInShopify = isTagInShopify(acceptance);

        if (cookieIsSet && tagInShopify) return true;
        if (cookieIsSet && !tagInShopify) {
          tags.push(acceptance);
          updateShopifyCustomerTags(customerId, new Set(tags));
          return true;
        }
        if (!cookieIsSet && tagInShopify) {
          setCookie(acceptance, true, 365);
          return true;
        }

        return false;
      });

      // eslint-disable-next-line no-param-reassign
      el.checked = shouldBeChecked;
    } else {
      // Handle the case where there is no customerId
      const shouldBeChecked = el.dataset.acceptance?.split(',').some((acceptance) => {
        const cookieIsSet = isCookieSet(acceptance);
        return cookieIsSet === true || cookieIsSet === 'true';
      });

      // eslint-disable-next-line no-param-reassign
      el.checked = shouldBeChecked;
    }
  });

  // eslint-disable-next-line no-unused-vars
  function updateGPCinOneTrust(value) {
    const marketingcookie = CheckandgetCookie('OptanonConsent');
    if (!marketingcookie) return;

    const boolInNumber = value ? 1 : 0;
    const updatedCookie = marketingcookie.replace(/isGpcEnabled=[0-1]/, `isGpcEnabled=${boolInNumber}`);
    setCookie('OptanonConsent', updatedCookie, 365);
  }

  function CheckandgetCookie(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    // eslint-disable-next-line no-plusplus
    for (let h = 0; h < ca.length; h++) {
      let c = ca[h];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  const redirect = () => {
    if (document.referrer.length > 0) {
      window.location.href = document.referrer;
    } else {
      window.location.href = '/';
    }
  };

  const updateOneTrust = () => {
    if (!window.OneTrust) return;
    let isInputChecked = false;
    const donotsellCheckbox = document.querySelector('input[data-acceptance="donotsell"]');
    const limittheuseCheckbox = document.querySelector('input[data-acceptance="limittheuse"]');

    if (donotsellCheckbox.checked || limittheuseCheckbox.checked) {
      isInputChecked = true;
    }

    if (isInputChecked) {
      window.OneTrust.UpdateConsent('Category', 'C0012:0');
      // setTimeout(redirect, 1000);
    } else {
      window.OneTrust.UpdateConsent('Category', 'C0012:1');
      // setTimeout(redirect, 1000);
    }
  };

  submitButton.addEventListener('click', async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    const consentParams = {};

    const updateTagsAndCookies = async () => {
      if (customerId) {
        const tags = new Set(customerTags);

        inputs.forEach((el) => {
          const acceptance = el.dataset.acceptance?.split(',');

          acceptance.forEach((accept) => {
            if (el.checked) {
              setCookie(accept, true, 365);
              tags.add(accept);
            } else {
              deleteCookie(accept);
              tags.delete(accept);
            }
          });

          const trackingConsent = el.dataset.trackingConsent?.split(',');
          trackingConsent.forEach((consent) => {
            consentParams[consent] = el.checked;
          });
        });

        if (Object.keys(consentParams).length > 0) {
          window.Shopify.customerPrivacy.setTrackingConsent(consentParams, () => console.log('Consent captured'));
        }

        try {
          await updateShopifyCustomerTags(customerId, Array.from(tags));
          console.log('Customer tags updated');
        } catch (error) {
          console.error('Failed to update customer tags:', error);
          // Exit if there's an error
        }
      } else {
        inputs.forEach((el) => {
          const acceptance = el.dataset.acceptance?.split(',');

          acceptance.forEach((accept) => {
            if (el.checked) {
              setCookie(accept, true, 365);
            } else {
              deleteCookie(accept);
            }
          });

          const trackingConsent = el.dataset.trackingConsent?.split(',');
          trackingConsent.forEach((consent) => {
            consentParams[consent] = el.checked;
          });
        });

        if (Object.keys(consentParams).length > 0) {
          window.Shopify.customerPrivacy.setTrackingConsent(consentParams, () => console.log('Consent captured'));
        }
      }
    };

    try {
      await updateTagsAndCookies();
      updateOneTrust();
      setTimeout(() => {
        redirect();
      }, 1000); // Adding a delay to ensure updates are processed
    } catch (error) {
      console.error('Error during update:', error);
    }
  });
};
